import { Image, ModalContent, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface UpSellingModalContentProps {
  description: ReactNode;
  imageSrc: string;
}

export default function UpSellingModalContent({
  description,
  imageSrc,
}: UpSellingModalContentProps) {
  return (
    <ModalContent mb={9} px={9}>
      <Text fontSize="md" fontWeight="regular" mb={7} textAlign="center">
        {description}
      </Text>
      <Image src={imageSrc} sx={{ borderRadius: '3px' }} />
    </ModalContent>
  );
}
